import React from "react";
import { CURRENCY_SYMBOL } from "../../../constant";
import {
  filterNumberColor,
  filterSign,
  formatNumber,
} from "../../../utils/formatNumber";
import LoadingIcon from "../../../components/Loading/LoadingIcon";
import { useTranslation } from "react-i18next";
import Copy from "../../../components/CopyComponent/Copy";
import { Divider } from "semantic-ui-react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const HistoryRecord = ({
  platformName,
  round_id,
  bet,
  winLose,
  settle_time,
  hash,
  typeIsBuffer,
  buffer_time,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`betRecord.${key}`);
  const memberData = useSelector((state) => state.isMemberInfo);

  return (
    <div
      className={`bg-base-light-white min-h-[145px] overflow-hidden dark:bg-base-light-dark rounded-[5px] py-common-padding-y px-common-padding-x relative`}
    >
      <div
        className={`h-[2px] w-full ${
          !typeIsBuffer ? "bg-green-500" : "bg-yellow-500"
        } absolute top-0 left-0`}
      ></div>
      <p className="text-transaction-text dark:text-base-light-white text-lg font-semibold mb-[5px] flex items-center">
        {platformName}
        {hash && ` ${hash}`}
      </p>

      <div className="">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-[6px]">
            <span className="text-sm font-medium text-base-light-dark dark:text-base-light-white">
              {i18n("roundId")}:
            </span>
            <span className="font-medium text-sm text-light-text">
              {round_id}
            </span>
            <Copy
              copyLink={
                !typeIsBuffer
                  ? `Player:${
                      memberData?.memId
                    },Platform:${platformName},RoundId:${round_id},SettleDate:${settle_time},Bet:${formatNumber(
                      bet,
                      { point: false }
                    )},WinLose:${formatNumber(winLose, { point: false })}`
                  : `Player:${
                      memberData?.memId
                    },Platform:${platformName},RoundId:${round_id},CreateDate:${
                      buffer_time.lock_time
                    },ExpectedCompleteDate:${
                      buffer_time.unlock_time
                    },Bet:${formatNumber(bet, {
                      point: false,
                    })}`
              }
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-[3px] justify-between items-start">
        {!typeIsBuffer ? (
          <div className="flex items-center gap-[6px]">
            <span className="text-sm font-medium text-base-light-dark dark:text-base-light-white">
              {i18n("settle_time")}:
            </span>
            <span className="font-medium text-sm text-light-text">
              {dayjs(settle_time).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </div>
        ) : (
          Object.keys(buffer_time).map((item) => {
            return (
              <div className="flex items-center gap-[6px]">
                <span className="text-sm font-medium text-base-light-dark dark:text-base-light-white">
                  {i18n(item)}:
                </span>
                <span className="font-medium text-sm text-light-text">
                  {dayjs(buffer_time?.[item]).format("YYYY-MM-DD HH:mm:ss")}
                </span>
              </div>
            );
          })
        )}
      </div>
      <Divider className="!my-[5px]" />
      <div className="flex justify-between">
        <div className="flex flex-col text-light-text">
          <p className="text-xs mb-[5px]">
            {typeIsBuffer ? i18n("payout") : i18n("Bet")}
          </p>
          <p className="font-bold text-light-text">
            {CURRENCY_SYMBOL} {formatNumber(bet, { point: false })}
          </p>
        </div>

        {!typeIsBuffer && (
          <div className="flex flex-col text-light-text">
            <p className="text-xs mb-[5px]">{i18n("Win/Lose")}</p>
            <p className={`font-bold ${filterNumberColor(winLose)}`}>
              {CURRENCY_SYMBOL} {formatNumber(winLose, { point: false })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoryRecord;
